import { render, staticRenderFns } from "./PackagesKanban.vue?vue&type=template&id=2a0e5d46&scoped=true&"
import script from "./PackagesKanban.vue?vue&type=script&lang=js&"
export * from "./PackagesKanban.vue?vue&type=script&lang=js&"
import style0 from "./PackagesKanban.vue?vue&type=style&index=0&id=2a0e5d46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e5d46",
  null
  
)

export default component.exports